import styled from 'styled-components';
import { visibleScrollbar } from '../../../styledMixins';

export const MainContainer = styled.div`
  width: 100%;
  position: relative;
  align-items: flex-start;
  background-color: var(--white);
  display: flex;
  flex-direction: row;
  position: relative;
`;

export const InnerContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: 100%;
  min-height: 90vh;
  position: relative;
`;

export const RightContainer = styled.div`
  width: 100%;
  background: #ffffff;
  overflow-y: auto;
  ${visibleScrollbar}
`;

export const RightSideHeader = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px 20px;
  gap: 12px;
  flex-wrap: wrap;
  border: 0px 0px 1px 0px;
  border-bottom: 1px solid var(--color-neutral-alpha-90, #c9c6cc80);

  @media (max-width: 765px) {
    flex-direction: column;
    align-items: flex-start;
  }
`;

export const PlusIcon = styled.img`
  display: none;
`;

export const PlusIconHover = styled.img`
  width: 20px;
  height: 20px;
  display: block;
`;

export const PlusText = styled.p`
  font-family: IBM Plex Sans;
  font-size: 16px;
  font-weight: 500;
  line-height: 24px;
  text-align: left;
  color: #ffffff;
  margin: 0;
`;

export const CreateButtonContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;
  cursor: pointer;
  position: relative;
  background-color: #7200E0;
  padding: 8px 16px;
  border-radius: 24px;
  width: fit-content;

  &:hover {
    background-color: #51009f;
  }

  &.selected {
    background-color: #51009f;
  }
`;

export const RightSideOptions = styled.div`
  display: flex;
  align-items: center;
  gap: 20px;
  flex-wrap: wrap;

  @media (max-width: 1024px) {
    gap: 12px;
  }

  @media (max-width: 765px) {
    width: 100%;
    gap: 10px;
  }
`;

export const SearchContainer = styled.div`
  display: flex;
  align-items: center;
  position: relative;
`;

export const SearchInputWrapper = styled.div`
  position: relative;
  display: flex;
  align-items: center;
`;

export const SearchIconImg = styled.img`
  position: absolute;
  right: 8px;
  width: 14px;
  height: 14px;
  z-index: 0;
  opacity: 0.7;
  pointer-events: none;
`;

export const ImportFileLabel = styled.label`
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 4px 8px;
  border: 1px solid #7200E0;
  border-radius: 25px;
  cursor: pointer;
  text-align: center;
  transition: all 0.2s ease;
  background-color: #ffffff;

  &:hover {
    background-color: #f2f1f380;
    border-color: #51009f;
  }
`;

export const ImportFile = styled.input`
  display: none;
`;

export const CardImgCont = styled.div`
  padding: 8px;
  gap: 2px;
  border-radius: 4px;
  border: 1;
  border: 1px solid #c9c6cc;
`;

export const CardImg = styled.img`
  width: 20px;
  height: 20px;
`;

export const UploadIcon = styled.img`
  width: 20px;
  height: 20px;
`;

export const CardTitle = styled.span`
  font-family: IBM Plex Sans;
  font-size: 16px;
  font-weight: 500;
  line-height: 24px;
  letter-spacing: 0em;
  text-align: left;
  color: #7200E0;
`;

export const HeadingAndFilterContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding: 20px 20px;
  width: 100%;
  border-bottom: 1px solid var(--Foundation-Grey-grey-100, #d6d6d6);
`;

export const BulkActionsContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px 20px;
  width: 100%;
  background: var(--color-purple-70, #FBF7FE);
  flex-wrap: wrap;
`;

export const SelectedCountText = styled.span`
  font-family: IBM Plex Sans;
  font-size: 14px;
  font-weight: 500;
  color: #4b464f;
  margin-right: 8px;
`;

export const BulkActionButton = styled.button`
  display: flex;
  align-items: center;
  gap: 4px;
  padding: 6px 12px;
  border-radius: 20px;
  color: #301B72;
  font-family: IBM Plex Sans;
  font-size: 14px;
  background: var(--color-neutral-white, #FFFFFF);
  border: 1px solid #301B72;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
  
  &:hover {
    transform: scale(1.05);
  }
  
  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;

export const BulkActionIcon = styled.img`
  width: 26px;
  height: 26px;
`;

export const MarkingCriteriaList = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  height: 81vh;
  width: 100%;
  position: relative;
  align-self: stretch;
  overflow: hidden;
`;

export const MarkingCriteriaListInner = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  width: 100%;
`;

export const ListAreaWrapper = styled.div`
  position: relative;
  min-height: 81vh;
`;

export const ListLoaderOverlay = styled.div`
  position: absolute;
  inset: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 10px;
  background: rgba(255, 255, 255, 0.85);
  z-index: 10;

  lottie-player {
    width: 100px;
    height: 100px;
  }
`;

export const ListLoaderText = styled.span`
  font-family: 'IBM Plex Sans', sans-serif;
  font-size: 15px;
  color: #1e252a;
`;

export const PopUpContainer = styled.div`
  display: flex;
  flex-direction: column;
  z-index: 5;
  position: absolute;
  top: 75px;
  background: var(--color-neutral-white, #ffffff);
  box-shadow: 0px 8.16px 16px 0px #7b738240;
  border-radius: 8px;
`;

export const PopUpCard = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  gap: 16px;
  padding: 16px 20px;
  cursor: pointer;
  
  &:hover {
    background-color: #f2f1f380;
  }
`;

export const PopUpCardImg = styled.img`
  width: 36px;
  height: 36px;
  gap: 4px;
  opacity: 0px;
`;

export const PopUpCardText = styled.span`
  font-family: IBM Plex Sans;
  font-size: 16px;
  font-weight: 500;
  line-height: 24px;
  text-align: left;
  color: #4b464f;
`;

export const DragHandle = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  cursor: grab;
  margin-left: 12px;
  border-radius: 4px;
  transition: background-color 0.2s ease;
  flex-shrink: 0;
  background-color: transparent;
  
  &:active {
    cursor: grabbing;
  }
  
  &:hover {
    background-color: #f5f5f5;
  }
`;

export const DragDots = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-template-rows: repeat(3, 1fr);
  gap: 2px;
  width: 14px;
  height: 14px;
`;

export const DragDot = styled.div`
  width: 4px;
  height: 4px;
  background-color: #999;
  border-radius: 50%;
  transition: background-color 0.2s ease;
  
  ${DragHandle}:hover & {
    background-color: #666;
  }
`;

export const SortableItemContainer = styled.div`
  z-index: 1;
  position: relative;
  width: 100%;
  
  &.dragging {
    z-index: 999;
    opacity: 0.8;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
  }
`;

export const SortableContentWrapper = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
`;

export const SortableChildrenContainer = styled.div`
  flex: 1;
  width: 100%;
`; 